import React from "react";
import { PropTypes } from "prop-types";
import { MrbListPage } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";
import { isDiscardableStatus } from "administration/naki-nigun-import/stores";

function NakiNigunImportBatchRowActions({ actions, item, t }) {
    if (!isDiscardableStatus(item.status)) {
        return null;
    }

    return (
        <button
            type="button"
            className="c-btn c-btn--sml c-btn--ghost"
            onClick={(event) => {
                // Prevent the row click (navigate to preview) from firing.
                event.preventDefault();
                event.stopPropagation();
                actions.discard.onClick(item);
            }}
        >
            {t(actions.discard.label)}
        </button>
    );
}

function NakiNigunImportBatchListTemplate({ nakiNigunImportBatchListViewStore, t }) {
    const { gridStore } = nakiNigunImportBatchListViewStore;
    return (
        <MrbListPage store={nakiNigunImportBatchListViewStore} t={t}>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine"
                emptyStateRender={TableNoDataOverlay}
                ActionsComponent={NakiNigunImportBatchRowActions}
            />
        </MrbListPage>
    );
}

NakiNigunImportBatchListTemplate.propTypes = {
    nakiNigunImportBatchListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(NakiNigunImportBatchListTemplate);
